import base from './base.html';

export default {
  title: 'Base',
  author: 'tianyanrong',
  html: [base],
  isCode: false,
};
